// (De)serializes the Builder's saveable state so a named view can round-trip
// through the per-user config store (stored in `extras`).
//
// The only non-JSON piece is `filterValues`, whose values are Sets (the pivot
// Filters zone). They become arrays on the way out and Sets on the way in.

import { VALUE_COUNT, VALUE_MODES } from "./formatValue";
import { DEFAULT_STAT, MEASURE_COUNT, MEASURE_KEYS, STATS } from "./measures";

const VERSION = 1;

/**
 * @returns {Object} a plain, JSON-safe snapshot
 */
export const serializeView = ({
  appliedFilters,
  assignments,
  filterValues,
  depthByCatalog,
  view,
  chartType,
  seriesKey,
  valueMode,
  measure,
  stat,
}) => ({
  v: VERSION,
  appliedFilters: appliedFilters ?? null,
  assignments: {
    rows: assignments.rows,
    cols: assignments.cols,
    filters: assignments.filters,
  },
  filterValues: Object.fromEntries(
    Object.entries(filterValues || {}).map(([k, set]) => [k, [...set]])
  ),
  depthByCatalog: depthByCatalog || {},
  view,
  chartType,
  seriesKey,
  valueMode,
  measure: measure || MEASURE_COUNT,
  stat: stat || DEFAULT_STAT,
});

/**
 * Inverse of serializeView. Tolerant of missing keys so older or partial
 * snapshots still load with sensible defaults.
 * @returns {Object} state ready to feed back into the Builder's setters
 */
export const deserializeView = (raw = {}) => ({
  appliedFilters: raw.appliedFilters ?? undefined,
  assignments: {
    rows: raw.assignments?.rows || [],
    cols: raw.assignments?.cols || [],
    filters: raw.assignments?.filters || [],
  },
  filterValues: Object.fromEntries(
    Object.entries(raw.filterValues || {}).map(([k, arr]) => [
      k,
      new Set(arr || []),
    ])
  ),
  depthByCatalog: raw.depthByCatalog || {},
  view: raw.view === "chart" ? "chart" : "table",
  chartType: raw.chartType || "pie",
  seriesKey: raw.seriesKey || "__total__",
  valueMode: VALUE_MODES.includes(raw.valueMode) ? raw.valueMode : VALUE_COUNT,
  // Views saved before measures existed are counts.
  measure: MEASURE_KEYS.includes(raw.measure) ? raw.measure : MEASURE_COUNT,
  stat: STATS.includes(raw.stat) ? raw.stat : DEFAULT_STAT,
});
